// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__IIuOM","productName":"Table_productName__3v8WF"};